import React, { Component } from 'react';
import { Table } from "reactstrap";
import './Products.css';
import { Copy, Edit2, Trash } from "react-feather";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Moment from "moment";
import AddShoeRotationWidgetModal, { buildWidgetSnippet, copyToClipboard } from "./modals/AddShoeRotationWidgetModal";
import DeleteShoeRotationWidgetModal from "./modals/DeleteShoeRotationWidgetModal";
import { apiFetch, API } from "../services/api";

const emptyWidget = () => ({
    id: "",
    title: "",
    intro: "",
    language: "fr",
    items: [],
});

function getShoeRotationWidgets() {
    return apiFetch(API.back + '/shoe-rotation-widgets', { method: 'GET' })
        .then(data => data.json())
        .catch(err => console.log(err));
}

// Catalogue chaussures : sert de sélecteur de produit dans la modale.
function getShoes() {
    return apiFetch(API.products + '/small-products?headCategories=/products/shoes', { method: 'GET' })
        .then(data => data.json())
        .catch(err => console.log(err));
}

export class ShoeRotationWidgetsList extends Component {
    state = {
        widgets: null,
        availableProducts: null,
        errors: null,
        isOpen: false,
        isDelete: false,
        copiedId: null,
        selectedWidget: emptyWidget(),
    };

    async componentDidMount() {
        await this.refresh();
        await getShoes().then(data => {
            this.setState({ availableProducts: Array.isArray(data) ? data : [] });
        }).catch(() => this.setState({ availableProducts: [] }));
    }

    refresh = async () => {
        return getShoeRotationWidgets().then(data => {
            this.setState({ widgets: Array.isArray(data) ? data : [], errors: null });
        }).catch(() => this.setState({ errors: "error while getting shoe rotation widgets" }));
    };

    closeModal = () => this.setState({ isOpen: false, isDelete: false, selectedWidget: emptyWidget() });

    handleCopy = (widget) => {
        copyToClipboard(buildWidgetSnippet(widget))
            .then(() => {
                this.setState({ copiedId: widget.id });
                setTimeout(() => this.setState({ copiedId: null }), 2500);
            })
            .catch(err => console.log(err));
    };

    render() {
        const { widgets, errors, availableProducts } = this.state;

        return (
            <div className="products-list">
                <Row>
                    <Col sm={12} className="products-buttons">
                        <Button className="add-product-button" variant="secondary"
                                onClick={() => this.setState({ isOpen: true, selectedWidget: emptyWidget() })}>
                            Ajouter un widget rotation
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className="products-buttons">
                        {widgets && errors == null
                            ? <span>{widgets.length} widget{widgets.length === 1 ? "" : "s"}</span>
                            : null}
                    </Col>
                </Row>

                {errors != null ? <p>Erreur lors de la récupération des widgets, veuillez vous reconnecter</p> : null}

                {(!widgets && errors == null) ? <p>Chargement ...</p> :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Titre</th>
                            <th>Langue</th>
                            <th>Chaussures</th>
                            <th>Modifié le</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {widgets && widgets.map(widget => (
                            <tr key={widget.id}>
                                <td>{widget.title}</td>
                                <td>{(widget.language || "fr").toUpperCase()}</td>
                                <td>{widget.items ? widget.items.length : 0}</td>
                                <td>{widget.modifiedDate ? Moment(widget.modifiedDate).format("DD/MM/YYYY HH:mm") : "—"}</td>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Modifier</Tooltip>}>
                                    <td className="table-action" style={{ cursor: "pointer" }}>
                                        <Edit2 className="align-middle" size={18}
                                               onClick={() => this.setState({ isOpen: true, selectedWidget: widget })}/>
                                    </td>
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Copier le snippet</Tooltip>}>
                                    <td className="table-action" style={{ cursor: "pointer" }}>
                                        <Copy className="align-middle" size={18} onClick={() => this.handleCopy(widget)}/>
                                        {this.state.copiedId === widget.id
                                            ? <span style={{ marginLeft: 6, fontSize: 11 }}>Copié !</span>
                                            : null}
                                    </td>
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Supprimer</Tooltip>}>
                                    <td className="table-action" style={{ cursor: "pointer" }}>
                                        <Trash className="align-middle" size={18}
                                               onClick={() => this.setState({ isDelete: true, selectedWidget: widget })}/>
                                    </td>
                                </OverlayTrigger>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }

                {this.state.isOpen ?
                    <AddShoeRotationWidgetModal
                        key={this.state.selectedWidget.id || "new"}
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        selectedWidget={this.state.selectedWidget}
                        availableProducts={availableProducts}
                        refresh={this.refresh}
                    /> : null}

                {this.state.isDelete ?
                    <DeleteShoeRotationWidgetModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        selectedItem={this.state.selectedWidget}
                        refresh={this.refresh}
                    /> : null}
            </div>
        );
    }
}
